import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import moment from "moment";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useModuleSettings } from "../../components/moduleSettingsContext/ModuleSettingsContext";
import { showPromiseNotification } from "../../common/notification";
import Loader from "../../components/loader";
import ViewModal from "./model";
import { complaintFeedback } from "../../slices/complaintFeedbackSlice";
import { FullscreenModel } from "./fullscreenModel";

const ComplaintFeedback = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { complaintFeedbackList } = useSelector((state) => state.complaintFeedback);
    const { filter, setFilter, search, setSearch, page, setPage, limit, setLimit, resetSettings } = useModuleSettings();
    const [description, setDescription] = useState('');

    const DescOptions = [
        { label: "Developer Issue", value: "Developer Issue" },
        { label: "UI/UX Issue", value: "UI/UX Issue" },
        { label: "Other", value: "Other" },
    ]

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);
    const [modalImage, setModalImage] = useState(null);
    const [data, setData] = useState({});
    const [field, setField] = useState({});
    const openImageModal = (image) => {
        setModalImage(image);
        setIsFullscreenOpen(true);
    };

    useEffect(() => {
        dispatch(complaintFeedback({ page, limit, description }));
    }, [dispatch, page, limit, description]);

    const handleView = (row) => {
        setField({
            tag: 1,
            title: "Complaint Feedback Details",
            full_name: "Full Name",
            phone_number: "Phone Number",
            description: "Description",
            image: "Image",
            date: "Date"
        })
        setData(row);
        setIsModalOpen(true)
    };

    const handleCloseModal = () => {
        setField({})
        setData({})
        setIsModalOpen(false);
    };

    const handleDescriptionChange = (event) => {
        const newDescription = event.target.value;
        resetSettings();
        setDescription(newDescription);
    };

    const columns = [
        {
            name: "Sr No",
            selector: (row, index) => (page - 1) * limit + index + 1,
            sortable: false,
            width: "80px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Complaint Feedback Id",
            selector: (row, index) => row.id,
            sortable: true,
            minWidth: "200px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Full Name",
            selector: (row) => row.full_name,
            sortable: true,
            minWidth: "200px",
            maxWidth: "400px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Phone Number",
            selector: (row) => (
                <>
                    {"+" + row.country_code + row.phone_number || "NA"}
                </>
            ),
            sortable: false,
            minWidth: "200px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Image",
            selector: (row) => (
                <img
                    src={row.image}
                    alt="image"
                    style={{ width: "60px", height: "60px", padding: "5px", cursor: "pointer" }}
                    onClick={() => openImageModal(row.image)}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = process.env.PUBLIC_URL + "/assets/images/no-image-vector.svg";
                    }}
                />
            ),
            minWidth: "150px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Description",
            selector: (row) => row.description,
            sortable: !description,
            minWidth: "200px",
            maxWidth: "400px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Created Date",
            selector: (row) => moment(row.createdAt).format("DD-MMM-YYYY"),
            minWidth: "150px",
            sortable: true,
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Action",
            selector: (row) => (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button className="btn" onClick={() => handleView(row)}>
                        <i
                            className="fe-eye font-22 avatar-title text-primary"
                            style={{ color: "blue" }}
                        />
                    </button>
                </div>
            ),
            minWidth: "150px",
            style: {
                fontSize: "14px",
                display: "flex",
                justifyContent: "center",
            },
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                justifyContent: "center",
            },
        },
    };

    if (!complaintFeedbackList?.data) {

        return (
            <Loader />
        )
    }

    return (
        <>
            <Helmet>
                <title>LEA.TRAINING | Complaint Feedback</title>
            </Helmet>

            <div className="content-page">
                <div className="col-md-12 col-xl-12 mt-1">
                    <div className={`widget-rounded-circle card`}>
                        <div className="card-body">
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                {/* <div>
                                    <h3 className="text-info">Category</h3>
                                </div> */}
                            </div>
                            <div className="row">
                                <DataTable
                                    title={"Complaint Feedback"}
                                    columns={columns}
                                    data={complaintFeedbackList?.data}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={complaintFeedbackList?.paging?.total}
                                    paginationDefaultPage={page}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
                                    onChangeRowsPerPage={(newrow) => setLimit(newrow)}
                                    onChangePage={(newPage) => setPage(newPage)}
                                    responsive
                                    selectableRowsHighlight
                                    highlightOnHover
                                    striped
                                    subHeader
                                    fixedHeader
                                    fixedFooter
                                    persistTableHead
                                    subHeaderWrap
                                    subHeaderAlign="left"
                                    noDataComponent={<h5 className="p-3">No Data Found</h5>}
                                    subHeaderComponent={
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                            <div className="ms-auto">
                                                <select value={description} onChange={handleDescriptionChange} style={{ padding: "5px 20px" }}>
                                                    <option value=''>
                                                        ALL
                                                    </option>
                                                    {DescOptions?.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    }
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ViewModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                data={data}
                field={field}
                openImageModal={openImageModal}
            />

            <FullscreenModel isModalOpen={isFullscreenOpen} setIsModalOpen={setIsFullscreenOpen} modalImage={modalImage} setModalImage={setModalImage} />
        </>
    );
};

export default ComplaintFeedback;